module.exports = __webpack_public_path__ + "img/image4.fa5be07.webp";